import React, { Component } from 'react'
import { Trans } from '@lingui/react'

import urlFor, { QueryParams } from 'shared/tools/url-helper'
import bookHelper from 'shared/tools/book-helper'
import audioBookHelper from 'shared/tools/audiobook-helper'
import comicbookHelper from 'shared/tools/comicbook-helper'
import uiBox from 'client/shared/decorators/ui-box'

import UserSectionActionsMenuBox from 'client/bookmate/boxes/user-section-actions-menu-box'
import Spacer from 'client/shared/blocks/spacer'
import { LayoutColumn } from 'client/shared/blocks/layout-column'
import { Book } from 'client/shared/blocks/book'
import AudioBook from 'client/bookmate/blocks/audiobook'
import { Comicbook } from 'client/shared/blocks/comicbook'

import './user-sub-header-books.styl'
import { RecentItem } from 'client/shared/types/user'
import { User } from 'client/shared/types/current-user'

const NUMBER_OF_ITEMS_TO_DISPLAY = 5

type Props = {
  user: User
  recentItems: RecentItem[]
  query?: QueryParams
}

class _UserSubHeaderBooks extends Component<Props> {
  render() {
    const {
      user: { myself },
    } = this.props

    return (
      <div className="user-sub-header-books">
        <LayoutColumn>
          {this.renderContents()}
          {myself && (
            <div className="user-sub-header-books__activities">
              <Spacer />
              <UserSectionActionsMenuBox />
            </div>
          )}
        </LayoutColumn>
      </div>
    )
  }

  renderContents() {
    const { recentItems } = this.props

    if (!recentItems.length) return this.renderEmptyMessage() // FIXME — loader

    return (
      <div className="user-sub-header-books__inner">
        {/* eslint-disable-next-line array-callback-return */}
        {recentItems.slice(0, NUMBER_OF_ITEMS_TO_DISPLAY).map((item, index) => {
          if (item.type === 'book') {
            return this.renderBook(item.entity, index)
          } else if (item.type === 'audiobook') {
            return this.renderAudiobook(item.entity, index)
          } else if (item.type === 'comicbook') {
            return this.renderComicbook(item.entity, index)
          }
        })}
      </div>
    )
  }

  renderEmptyMessage() {
    return (
      <div className="user-sub-header-books__no-book">
        <div className="user-sub-header-books__no-book-title">
          <Trans id="profile.no_book_title" />
        </div>
        <a
          className="user-sub-header-books__no-book-link"
          href={urlFor.library(this.props.query)}
        >
          <Trans id="profile.no_book_link" />
        </a>
      </div>
    )
  }

  renderBook(book, index) {
    const serialInfo =
      book.resourceType === 'serial' ? urlFor.getSerialReaderQuery(book) : ''

    return (
      <Book
        isUserBooksPage
        key={index}
        book={book}
        kind="grid"
        coverSize={88}
        hoverable={false}
        serialInfo={serialInfo}
        progress={book.library_card && book.library_card.progress}
        description={false}
        inPrivate={bookHelper.isPrivate(book.library_card)}
      />
    )
  }

  renderAudiobook(audiobook, index) {
    return (
      <AudioBook
        key={index}
        audiobook={audiobook}
        kind="grid"
        progress={audioBookHelper.getProgressInPercent(audiobook)}
        description={false}
        coverSize={124}
        inPrivate={audioBookHelper.isPrivate(audiobook)}
      />
    )
  }

  renderComicbook(comicbook, index) {
    return (
      <Comicbook
        key={index}
        comicbook={comicbook}
        kind="grid"
        progress={comicbookHelper.getProgressInPercent(comicbook)}
        description={false}
        coverSize={88}
        inPrivate={comicbookHelper.isPrivate(comicbook)}
      />
    )
  }
}

export const UserSubHeaderBooks = uiBox(_UserSubHeaderBooks)
